<div class="drugs-by-company-container">
  <div class="header">
    <div class="chart-title">
      <span>Company</span>
    </div>
    <div class="chart-info">
      <span
        ># of Drugs<span *ngIf="totalCount > 10">
          | Displaying 10 out of {{ totalCount }} Companies</span
        ></span
      >
    </div>
  </div>
  <div class="chart-container">
    <nz-spin nzTip="Crunching numbers..." *ngIf="!chartReady" class="spinner">
    </nz-spin>
    <highcharts-chart
      *ngIf="chartReady && !showError"
      [Highcharts]="highcharts"
      [options]="chartOptions"
      [(update)]="updateFlag"
      style="width: 100%; height: 100%; display: block"
      ngClass="company"
    >
    </highcharts-chart>
    <div id="charts-error" class="error-container" *ngIf="showError">
      <div class="error-msg">
        <va-icon size="small" name="info-circle" class="info-icon"></va-icon>
        <span class="error-text">{{
          errorMessage ? errorMessage : "Something went wrong!"
        }}</span>
      </div>
    </div>
  </div>
  <div
    class="rank-info"
    *ngIf="
      chartReady &&
      selectedRank > 10 &&
      chartFilters.company_id != '' &&
      chartFilters.company_id === selectedCompanyId
    "
  >
    <va-icon size="small" name="info-circle" class="info-icon"></va-icon>
    <span> Selected company's actual rank is {{ selectedRank }}</span>
  </div>
</div>
